import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { Util } from '../../../config/Util';

function LaunchCommunication(arg) {
  const [show, setShow] = useState(arg.flag);
  const [finish, setFinish] = useState(false);

 
  // const [trainingStarted , setTrainingStarted] = useState(false);
  // const [counter, setCounter] = useState(0);

  
  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const {data} = arg;
  console.log(data);
  // const question = data.trainingData || [];
  // const handleShow = () => setShow(true);

  // //Start training
  // const startTraining = ()=>{
  //   setTrainingStarted(true);
  // }
  // //Next 
  // const handleNextClick =()=>{
  //   if((counter+1) === question.length) return;
  //   setCounter(counter+1);
  // }
  // //Previous
  // const handlePreviousClick =()=>{
  //   if(counter >0) setCounter((counter-1));
  // }


  //Finish
  const updateStatus=()=>{
    //Call finish api to update the status
    arg.updateStatus();
    setFinish(true);
  }
  
  

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false} size="lg">
        <Modal.Header>
          <Modal.Title>Communication</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
            <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Title</Form.Label>
                  <Form.Control value={data.name} type="text" disabled/>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={3} value={data.description} disabled />
                </Form.Group>

                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  
                  {
                    (data.mediaType === "video") && (
                      <video  controls>
                            <source src={Util.baseURlForDownload+data.file} type="video/mp4"></source>
                      </video>
                    )
                  }
                  {
                    (data.mediaType === "image") && (
                      <img src={Util.baseURlForDownload+data.file} className='qstn-assessment-image'/>
                    )
                  }
                  {
                    (data.mediaType === "pdf") && (
                     
                      <iframe
                            title="PDF Viewer"
                            src={`https://docs.google.com/viewer?url=${Util.baseURlForDownload+data.file}&embedded=true`}
                            width="100%"
                            height="400"
                            frameborder="0"
                          />
                    
                    )
                  }
                </Form.Group>
                
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <a href={Util.baseURlForDownload+arg.data.file} download className='btn btn-info' onClick={()=>setFinish(true)}> Download File</a>

                  {/* <input type='button' className='btn btn-info'   value='Download File'></input> */}
                </Form.Group>
                
              </Form>
            
           
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CLOSE
          </Button>
          <Button variant="primary" onClick={updateStatus} >
            OK
          </Button>
          
            
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LaunchCommunication;

